'use strict';

import config from '../../utils/config';
import logger from '../../utils/logger';

const classNames = {
	privacySettings: 'privacy-settings'
}

export default {
	init: function () {
		$.findByBem(classNames.privacySettings).on('click.footer', function (e) {
			e.preventDefault();
			if (window._sp_ && window._sp_.loadPrivacyManagerModal) {
				window._sp_.loadPrivacyManagerModal(config.privacyManagerId);
			} else {
				logger.debug('CMP: Sourcepoint privacy manager script not loaded');
			}
		});
	}
}